import './common/fix-header-on-scroll.js';
import './common/update-year.js';
import './common/bg-animation.js';
import './common/promo-img-animation.js';
import './common/parallax-animation.js';
import './common/show-video.js';